// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module__container___mZD-o","inputBox":"index-module__inputBox___jmZBb","largeInput":"index-module__largeInput___337Hf"};